import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      BUTTON_TEXT: "Pause abonnementet",
    },
    dk: {
      BUTTON_TEXT: "Opsig abonnement",
    },
    se: {
      BUTTON_TEXT: "Avsluta prenumeration",
    },
  } as const
)[language];
